module.exports = __webpack_public_path__ + "media/images/top/title_kvPC-1cc3a93912b8a1bb7af55cb7a5537bdb.svg";